//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 電柱一覧/径間選択
//------------------------------------------------------------------------------
import PoleItem from '@/utils/pole-item';
import PoleLink from '@/utils/pole-link';

/**
 * 径間選択描画 (FlexGrid の formatItem 処理)
 */
export function renderKeikanSelect(s, e) {
  const item = s.rows[e.row].dataItem;

  // 左側チェックボックス
  const checkbox1st =`
    <label class="link1st">
      <input
        type="checkbox"
        data-type="link1st"
        ${item.kknSelect?.pole1st ? 'checked' : ''}
      />
    </label>`;

  // 右側チェックボックス
  const checkbox2nd = `
    <label class="link2nd">
      <input
        type="checkbox"
        data-type="link2nd"
        ${item.kknSelect?.pole2nd ? 'checked' : ''}
      />
    </label>`;

  // 左右チェックボックスを並べて表示
  e.cell.innerHTML = checkbox1st + checkbox2nd;
}

/**
 * 径間選択状態反映
 *
 * @param {CustomFlexGrid} グリッド
 * @param {PoleLink}       選択リンク
 * @return 電柱一覧に選択リンク(電柱x2)が両方とも存在するかどうかを返す
 */
export function applyKeikanSelect(grid, linkSelected) {

  // 径間選択なしなら全行チェックオフ
  if (!linkSelected || linkSelected.empty()) {
    grid.rows.forEach((row) => {
      const item = row.dataItem;
      item.kknSelect.pole1st = false;
      item.kknSelect.pole2nd = false;
    });

    // グリッド再描画
    grid.invalidate(false);
    return false;
  }

  // 電柱一覧を探索
  let row1st = null;
  let row2nd = null;
  for (const row of grid.rows) {

    // 電柱一致判定
    const item = row.dataItem;
    const same1st = linkSelected.pole1st?.same(item);
    const same2nd = linkSelected.pole2nd?.same(item);

    // チェックボックス状態設定
    item.kknSelect.pole1st = same1st;
    item.kknSelect.pole2nd = same2nd;

    // 一致した電柱のグリッド行
    if (same1st) row1st = row;
    if (same2nd) row2nd = row;
  }

  // 選択リンク存在判定
  return Boolean(row1st && row2nd);
}

/**
 * 径間選択クリック処理
 */
export function handleClickKeikanSelect(grid, checkbox, selfItem) {

  // チェックボックス属性
  const checked = checkbox.checked;
  const dataType = checkbox.dataset.type;

  // 左側チェックボックス
  if (dataType === 'link1st') {

    // チェックボックス状態更新
    return updateKeikanSelect(
        grid, checked, selfItem, 'pole1st', 'pole2nd');
  }

  // 右側チェックボックス
  if (dataType === 'link2nd') {

    // チェックボックス状態更新
    return updateKeikanSelect(
        grid, checked, selfItem, 'pole2nd', 'pole1st');
  }

  // チェックボックス以外
  return null;
}

//
// 径間選択状態更新
//
function updateKeikanSelect(grid, checked, selfItem, selfName, pairName) {
  const kknSelect = selfItem.kknSelect;

  // 項目値を更新
  kknSelect[selfName] = checked;

  // チェックオンなら隣の項目をオフに設定
  if (checked) {
    kknSelect[pairName] = false
  }

  // 全行探索
  const selected = {};
  for (const item of grid.itemsSource) {

    // チェックオンなら他の行を全てオフにする
    if (checked && item !== selfItem) {
      item.kknSelect[selfName] = false;
    }

    // チェックオンになっている行を探す
    if (item.kknSelect[selfName]) selected[selfName] = item;
    if (item.kknSelect[pairName]) selected[pairName] = item;
  }

  // グリッド再描画
  grid.invalidate(false);

  // 選択した径間リンク(電柱ペア)を返す
  return new PoleLink(
      selected.pole1st && new PoleItem(selected.pole1st),
      selected.pole2nd && new PoleItem(selected.pole2nd));
}
